/* ============================================================
   MB PRODOTTI — griglia /collections/all
   Filtri per tipo, ordinamento client-side e feedback del quick add.
   NB: in questo file non c'e' nessun backslash, per scelta:
   Shopify non valida il JS al caricamento e un escape sbagliato
   romperebbe la pagina in silenzio.
   ============================================================ */

(function () {
  var SORT_DEFAULT = 'consigliati';
  var REVERT_MS = 2200;
  var FALLBACK_MS = 1600;

  function norm(valore) {
    return (valore || '').toString().trim().toLowerCase();
  }

  function lista(root, selettore) {
    return Array.prototype.slice.call(root.querySelectorAll(selettore));
  }

  /* ---------- filtri + ordinamento ---------- */
  function initGriglia(root) {
    var grid = root.querySelector('[data-mbp-grid]');
    if (!grid) return;
    if (grid.dataset.mbpReady === '1') return;
    grid.dataset.mbpReady = '1';

    var cards = lista(grid, '[data-mbp-card]');
    var pills = lista(root, '[data-mbp-filter]');
    var select = root.querySelector('[data-mbp-sort]');
    var vuoto = root.querySelector('[data-mbp-empty]');
    var contatore = root.querySelector('[data-mbp-count]');
    var filtro = 'tutti';

    function applica() {
      var visibili = 0;
      cards.forEach(function (card) {
        var mostra = filtro === 'tutti' || norm(card.dataset.mbpTipo) === filtro;
        card.classList.toggle('is-hidden', !mostra);
        if (mostra) visibili = visibili + 1;
      });
      if (vuoto) vuoto.hidden = visibili > 0;
      if (contatore) contatore.textContent = visibili;
    }

    function ordina(modo) {
      var ordinate = cards.slice();
      ordinate.sort(function (a, b) {
        if (modo === 'prezzo-asc') {
          return Number(a.dataset.mbpPrezzo) - Number(b.dataset.mbpPrezzo);
        }
        if (modo === 'prezzo-desc') {
          return Number(b.dataset.mbpPrezzo) - Number(a.dataset.mbpPrezzo);
        }
        if (modo === 'nome') {
          return norm(a.dataset.mbpNome).localeCompare(norm(b.dataset.mbpNome));
        }
        return Number(a.dataset.mbpOrdine) - Number(b.dataset.mbpOrdine);
      });
      ordinate.forEach(function (card) { grid.appendChild(card); });
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (altra) { altra.classList.remove('is-active'); });
        pill.classList.add('is-active');
        filtro = norm(pill.dataset.mbpFilter);
        applica();
      });
    });

    if (select) {
      select.addEventListener('change', function () { ordina(select.value); });
      if (select.value && select.value !== SORT_DEFAULT) ordina(select.value);
    }

    applica();
  }

  /* ---------- feedback visivo del + (l'aggiunta la fa il form nativo) ---------- */
  function confermato(btn) {
    if (btn.dataset.state !== 'adding') return;
    var icona = btn.querySelector('[data-mbp-icon]');
    btn.dataset.state = 'added';
    if (icona) icona.className = 'fa-solid fa-check';
    setTimeout(function () {
      btn.dataset.state = '';
      if (icona) icona.className = 'fa-solid fa-plus';
    }, REVERT_MS);
  }

  function initQuickAdd(root) {
    lista(root, '[data-mbp-add]').forEach(function (btn) {
      if (btn.dataset.mbpBound === '1') return;
      btn.dataset.mbpBound = '1';
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        if (btn.dataset.state === 'adding' || btn.dataset.state === 'added') return;
        btn.dataset.state = 'adding';
        setTimeout(function () { confermato(btn); }, FALLBACK_MS);
      });
    });
  }

  var eventiCarrello = ['cart:update', 'cart:change', 'CartUpdateEvent'];
  eventiCarrello.forEach(function (nome) {
    document.addEventListener(nome, function () {
      lista(document, '[data-mbp-add][data-state="adding"]').forEach(confermato);
    });
  });

  function avvia() {
    lista(document, '[data-mbp-root]').forEach(function (root) {
      initGriglia(root);
      initQuickAdd(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }

  document.addEventListener('shopify:section:load', avvia);
})();
